import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "hidden", "empty"]

  connect() {
    this.render()
  }

  add(e) {
    e.preventDefault()
    const items = this.items()
    items.push({ name: "", hint: "", required: true, position: items.length + 1 })
    this.save(items)
    this.render()
    // Focus the last name input
    requestAnimationFrame(() => {
      const inputs = this.listTarget.querySelectorAll("input[data-field='name']")
      inputs[inputs.length - 1]?.focus()
    })
  }

  remove(e) {
    e.preventDefault()
    const idx = parseInt(e.currentTarget.dataset.index, 10)
    const items = this.items()
    items.splice(idx, 1)
    items.forEach((item, i) => { item.position = i + 1 })
    this.save(items)
    this.render()
  }

  update(e) {
    const field = e.currentTarget.dataset.field
    const idx   = parseInt(e.currentTarget.dataset.index, 10)
    const items = this.items()
    if (field === "required") {
      items[idx].required = e.currentTarget.checked
    } else {
      items[idx][field] = e.currentTarget.value
    }
    this.save(items)
  }

  items() {
    try {
      return JSON.parse(this.hiddenTarget.value || "[]")
    } catch {
      return []
    }
  }

  save(items) {
    this.hiddenTarget.value = JSON.stringify(items)
  }

  render() {
    const items = this.items()
    this.emptyTarget.style.display = items.length === 0 ? "block" : "none"
    this.listTarget.replaceChildren(...items.map((item, i) => this.createRow(item, i)))
  }

  createRow(item, i) {
    const row = document.createElement("div")
    row.className = "checklist-row"

    const num = document.createElement("div")
    num.className = "row-number"
    num.textContent = String(i + 1)

    const fields = document.createElement("div")
    fields.className = "row-fields"

    const nameInput = document.createElement("input")
    nameInput.type = "text"
    nameInput.className = "row-input row-name"
    nameInput.placeholder = "Nazwa dokumentu"
    nameInput.value = item.name ?? ""
    nameInput.dataset.field = "name"
    nameInput.dataset.index = String(i)
    nameInput.dataset.action = "input->checklist-template#update"

    const hintInput = document.createElement("input")
    hintInput.type = "text"
    hintInput.className = "row-input row-hint"
    hintInput.placeholder = "Wskazówka dla klienta (opcjonalna)"
    hintInput.value = item.hint ?? ""
    hintInput.dataset.field = "hint"
    hintInput.dataset.index = String(i)
    hintInput.dataset.action = "input->checklist-template#update"

    const label = document.createElement("label")
    label.className = "row-required"

    const checkbox = document.createElement("input")
    checkbox.type = "checkbox"
    checkbox.checked = !!item.required
    checkbox.dataset.field = "required"
    checkbox.dataset.index = String(i)
    checkbox.dataset.action = "change->checklist-template#update"

    label.appendChild(checkbox)
    label.append(" Wymagany")

    fields.append(nameInput, hintInput, label)

    const removeBtn = document.createElement("button")
    removeBtn.type = "button"
    removeBtn.className = "row-remove"
    removeBtn.title = "Usuń"
    removeBtn.textContent = "×"
    removeBtn.dataset.index = String(i)
    removeBtn.dataset.action = "click->checklist-template#remove"

    row.append(num, fields, removeBtn)
    return row
  }
}
